/**
 * Provides the active filter popover's close callback to nested content
 * (e.g. radio-option contextual fields) without prop drilling or render props.
 */
import React, { useContext } from "react";

const RmaListFilterPopoverCloseContext = React.createContext<(() => void) | null>(null);

interface IProviderProps {
    onRequestClose: () => void;
    children: React.ReactNode;
}

export const RmaListFilterPopoverCloseProvider: React.FC<IProviderProps> = ({
    onRequestClose,
    children,
}) => (
    <RmaListFilterPopoverCloseContext.Provider value={onRequestClose}>
        {children}
    </RmaListFilterPopoverCloseContext.Provider>
);

export const useRmaListFilterPopoverClose = (): (() => void) => {
    const onRequestClose = useContext(RmaListFilterPopoverCloseContext);
    if (!onRequestClose) {
        return () => undefined;
    }
    return onRequestClose;
};
